import React, { Component } from 'react';

import { getCharFilename } from './Utils.js';

import removeImg from './content/remove.png';

class CharacterImg extends Component {
    static defaultProps = { color:"gray", alt:0 };

    constructor(props) {
        super(props);
        this.remove = this.remove.bind(this);
    }

    remove() {
        if (typeof this.props.remove === "function") {
            this.props.remove(this.props.character);
        }
    }
    
    render() {
        let {character, color, alt} = this.props;

        return (
            <div className="CharacterImg">
              <img src={getCharFilename(character, alt, color)} alt={character}/>
              <img onClick={this.remove} className="remove" src={removeImg} alt="X" />
            </div>
        );
    }
}


export default CharacterImg;
